import { Spin } from 'antd';
import React, { useEffect, useRef } from 'react';
import videojs from 'video.js';
import 'video.js/dist/video-js.css'; // Import Video.js styles

const VideoEmbed = ({ demoReel, style = {} }) => {
  const videoRef = useRef(null);
  const playerRef = useRef(null); // Ref to store the Video.js player instance
  const isMp4 = demoReel.endsWith('.mp4'); // Check if the demoReel is an MP4 link

  // Video ID extraction with support for both Vimeo and YouTube
  const getVideoId = (url) => {
    if (!url) return { platform: null, id: null };
    try {
      const cleanUrl = url.trim();

      // Handle direct ID input
      if (cleanUrl.match(/^\d+$/)) return { platform: 'vimeo', id: cleanUrl };

      // Vimeo URL patterns
      const vimeoMatch = cleanUrl.match(/(?:vimeo\.com\/|player\.vimeo\.com\/video\/)(\d+)/);
      if (vimeoMatch) return { platform: 'vimeo', id: vimeoMatch[1] };

      // YouTube URL patterns
      const youtubeMatch = cleanUrl.match(/(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]+)/);
      if (youtubeMatch) return { platform: 'youtube', id: youtubeMatch[1] };

      return { platform: null, id: null };
    } catch (error) {
      console.error('Error parsing video URL:', error);
      return { platform: null, id: null };
    }
  };

  const { platform, id } = isMp4 ? { platform: 'mp4', id: null } : getVideoId(demoReel);

  const embedUrl = platform === 'mp4'
    ? demoReel.trim()
    : platform === 'vimeo'
      ? `https://player.vimeo.com/video/${id}?app_id=122963&color=ffd40b&autoplay=1&autopause=0&title=0&byline=0&playsinline=0&portrait=0&muted=1`
      : platform === 'youtube'
        ? `https://www.youtube.com/embed/${id}?autoplay=1&mute=1&playsinline=1&controls=1&modestbranding=1&rel=0`
        : '';

  useEffect(() => {
    if (platform === 'mp4' && videoRef.current) {
      // Initialize Video.js for MP4 links only if the videoRef is available
      if (!playerRef.current) {
        playerRef.current = videojs(videoRef.current, {
          controls: true,
          responsive: true,
          fluid: true,
        });
      }
    }

    // Cleanup function to dispose of the player on unmount
    return () => {
      if (playerRef.current) {
        // playerRef.current.dispose(); // Clean up the player on unmount
        playerRef.current = null; // Reset the player reference
      }
    };
  }, [platform]); // Dependency array includes platform to re-run effect if it changes

  if (!embedUrl) {
    return <div></div>;
  }

  return (<>

    <div style={{
      backgroundColor: 'black',
      position: 'relative',
      paddingBottom: '56.25%',
      height: 0,
      overflow: 'hidden',
      ...style
      }}>


      {platform === 'mp4' ? (
        <div data-vjs-player>
          <video ref={videoRef} className="video-js" style={{ width: '100%', height: '100%' }} controls muted>
            <source src={embedUrl} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      ) : (
        <iframe
          src={embedUrl}
          style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
          frameBorder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
            title={`${platform} Video`}
            muted
        ></iframe>
      )}
    </div>
  </>
  );
};

export default VideoEmbed;